@if (bookingStatusResponse){

<div class="row section__header">
  <div class="col-12 text-center">
    @if (bookingStatusResponse && (bookingStatusResponse.statusId === 2 || bookingStatusResponse.statusId === 3)){
    <span class="material-symbols-outlined header-icon">check_circle</span>

    @if (bookingStatusResponse.waitTime === -1){
    <h1 class="text-center">WAITING FOR THERAPIST TO BECOME AVAILABLE</h1>
    }
    @else if (therapistChanged){
    <h1 class="text-center">YOUR SELECTED THERAPIST IS UNAVAILABLE</h1>
    <p class="text-muted">We will assign you the next available therapist</p>
    }
    @else if (this.bookingAddEdit === 0){
    <h1 class="text-center">THANKS FOR BOOKING</h1>
    }@else{
    <h1 class="text-center">BOOKING UPDATED</h1>
    }
    <p class="text-muted">You are currently in a queue</p>
    }
    @if (bookingStatusResponse && bookingStatusResponse.statusId === 7){
    <span class="material-symbols-outlined header-icon">cancel</span>
    <h1>BOOKING CANCELLED</h1>
    }
    @if (bookingStatusResponse && bookingStatusResponse.statusId === 5){
    <span class="material-symbols-outlined header-icon">massage</span>
    <h1>TREATMENT IN PROGRESS</h1>
    }
    @if (bookingStatusResponse && bookingStatusResponse.statusId === 6){
    <span class="material-symbols-outlined header-icon">cheer</span>
    <h1>THANKS FOR USING WINNING HANDS</h1>
    }

    @if(bookingStatusResponse && bookingStatusResponse.statusId === 4){
    <span class="material-symbols-outlined header-icon">footprint</span>
    <h1>YOUR THERAPIST IS ON THE WAY</h1>
    }
  </div>
</div>



<div class="row section__body">
  <div class="col-12 text-center">
    @if (bookingStatusResponse.waitTime === -1){
    @if (bookingStatusResponse.contactMethodId === 1){
    <p>We will send you a SMS to {{bookingStatusResponse.mobileNumber}} when your therapist is ready</p>
    } @else {
    <p>We will send you a Whatsapp to {{bookingStatusResponse.mobileNumber}} when your therapist is ready</p>
    }
    }
    @else if (bookingStatusResponse && (bookingStatusResponse.statusId === 2 || bookingStatusResponse.statusId === 3) && bookingStatusResponse.waitTime){
      @if (bookingStatusResponse.queuePosition! > 0) {
      <p>You are currently in queue position {{bookingStatusResponse.queuePosition}}</p>
      }
    @if (bookingStatusResponse.contactMethodId === 1){
    <p>We will send you a SMS to {{bookingStatusResponse.mobileNumber}} when your therapist is ready</p>
    } @else {
    <p>We will send you a Whatsapp to {{bookingStatusResponse.mobileNumber}} when your therapist is ready</p>
    }
    }

    @else if (bookingStatusResponse && bookingStatusResponse.statusId === 7){
    <p class="text-muted">Sorry to hear you have cancelled your booking. We look forward to seeing you soon</p>
    }
    @else if (bookingStatusResponse && bookingStatusResponse.statusId === 5 || bookingStatusResponse.statusId === 4){
    <p class="text-muted">We hope you enjoy your massage</p>
    }
    @else if (bookingStatusResponse && bookingStatusResponse.statusId === 6){
    <p class="text-muted">We hope you enjoyed your massage</p>
    }
  </div>
</div>




<div class="row section__actions">
    <div class="col-12">
        @if (bookingStatusResponse && (bookingStatusResponse.statusId === 2 || bookingStatusResponse.statusId === 3 || bookingStatusResponse.statusId === 4)){
        <div class="row my-3">
            <div class="col-12">
                <button class="w-100" (click)="updateBooking();" mat-flat-button color="primary">AMEND BOOKING</button>
            </div>
        </div>
        <div class="row my-3">
            <div class="col-12">
                <button (click)="cancelBooking();" class="w-100" mat-button color="warn">CANCEL BOOKING</button>
            </div>
        </div>
        }

        @if (bookingStatusResponse && bookingStatusResponse.statusId === 6){
        <div class="row my-3">
            <div class="col-12">
                <button class="w-100" (click)="rebook();" mat-flat-button color="primary">REBOOK</button>
            </div>
        </div>
        }
        @if (bookingStatusResponse && bookingStatusResponse.statusId === 7){
        <div class="row my-3">
            <div class="col-12">
                <button class="w-100" (click)="rebook();" mat-flat-button color="primary">BOOK AGAIN</button>
            </div>
        </div>
        }
    </div>
</div>

}
@else {
<div class="wh-loading-bar">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
}
